import { useState, useEffect } from 'react';

const sections = [
  { id: 'hero', label: 'Resumen' },
  { id: 'revenue', label: 'Modelos' },
  { id: 'economics', label: 'Economics' },
  { id: 'market', label: 'Mercado' },
  { id: 'projections', label: 'Proyecciones' },
  { id: 'roadmap', label: 'Roadmap' },
  { id: 'risks', label: 'Riesgos' },
];

export function BizPlanNav() {
  const [scrolled, setScrolled] = useState(false);
  const [active, setActive] = useState('hero');

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);

      const offsets = sections.map(s => {
        const el = document.getElementById(s.id);
        return { id: s.id, top: el ? el.getBoundingClientRect().top : Infinity };
      });
      const current = offsets.find(o => o.top > -100 && o.top < 400);
      if (current) setActive(current.id);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <nav
      className={`fixed left-0 right-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'border-b border-white/10 bg-[#0F1B2E]/90 py-3 backdrop-blur-lg'
          : 'bg-transparent py-5'
      }`}
    >
      <div className="mx-auto flex max-w-6xl items-center justify-between px-4 sm:px-6">
        <div className="flex items-center gap-2">
          <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-emerald-500/20 ring-1 ring-emerald-400/30">
            <svg className="h-4 w-4 text-emerald-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 013 19.875v-6.75zM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V8.625zM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V4.125z" />
            </svg>
          </div>
          <span className="font-display text-sm font-bold text-white">Migro Business Plan</span>
        </div>

        <div className="hidden items-center gap-1 md:flex">
          {sections.map(s => (
            <button
              key={s.id}
              onClick={() => scrollTo(s.id)}
              className={`rounded-full px-3 py-1.5 text-xs font-medium transition ${
                active === s.id
                  ? 'bg-emerald-500/20 text-emerald-400'
                  : 'text-slate-400 hover:bg-white/5 hover:text-white'
              }`}
            >
              {s.label}
            </button>
          ))}
        </div>

        <a
          href="/abogados"
          className="rounded-lg bg-orange-500 px-4 py-2 text-xs font-semibold text-white shadow-lg shadow-orange-500/25 transition hover:scale-[1.02] hover:bg-orange-600 active:scale-[0.98]"
        >
          Unirse
        </a>
      </div>
    </nav>
  );
}
